// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1etFs","col":"styles_col__3MDf3"};